unit TermListGetResponse;
{

/* Initial. */

}
interface

uses
  JS, WEBLib.Dialogs,
  BaseResponse, TermListType;

type
  TTermListGetResponse = class(TBaseResponse)
  private
    fLanguage: String;
    fTermList: TTermListType;
  public
    property Language: String read fLanguage;
    property TermList: TTermListType read fTermList;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TTermListGetResponse.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  inherited Create(String_JSON);

  JSObject_Type := TJSJSON.parseObject(String_JSON);

  fLanguage := String(JSObject_Type['language']);
  fTermList := TTermListType.Create(TJSJSON.stringify(JSObject_Type['termList']));
end;

end.
